const initialDocHeader = (data, arrayResponse, setField, fieldRecordload) => {

    data.crud.boxes.forEach((itemBoxs) => {
        itemBoxs.fields.forEach((itemFields) => {
            if (itemFields.defaultValue) {
                let idField = itemFields.id;
                switch (itemFields.type) {
                    case 'Select':
                        if (arrayResponse) {
                            arrayResponse.forEach((itemInfo) => {
                                if (itemInfo.source === itemFields.sourceSelect) {
                                    if (Number(itemFields.defaultValue) === Number(itemInfo.id)) {

                                        setField(prevState => ({
                                            ...prevState,
                                            [idField]: {
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            }
                                        }), []);

                                        fieldRecordload[idField] = {
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        }

                                    }

                                }
                            })
                        }
                        break;
                    case 'Date':
                        if (itemFields.defaultValue === 'CURDATE()') {
                            setField(prevState => ({
                                ...prevState,
                                [idField]: new Date().toISOString().split('T')[0]
                            }), []);

                            fieldRecordload[idField] = new Date().toISOString().split('T')[0]
                        }

                        if (itemFields.defaultValue === 'BOM()') {

                            const date = new Date();
                            date.setDate(1);

                            setField(prevState => ({
                                ...prevState,
                                [idField]: date.toISOString().split('T')[0]
                            }));

                            fieldRecordload[idField] = date.toISOString().split('T')[0]
                        }

                        if (itemFields.defaultValue === 'BOY()') {
                            const date = new Date();
                            date.setMonth(0); // Enero
                            date.setDate(1);  // Día 1
                            setField(prevState => ({
                                ...prevState,
                                [idField]: date.toISOString().split('T')[0]
                            }));

                            fieldRecordload[idField] = date.toISOString().split('T')[0]
                        }
                        if (itemFields.defaultValue === 'YESTERDAY()') {
                            const date = new Date();
                            date.setDate(date.getDate() - 1);
                            setField(prevState => ({
                                ...prevState,
                                [idField]: date.toISOString().split('T')[0]
                            }));

                            fieldRecordload[idField] = date.toISOString().split('T')[0]
                        }
                        break;
                    case 'Switch':
                        if (itemFields.defaultValue === '0') {
                            setField(prevState => ({
                                ...prevState,
                                [idField]: false
                            }), []);

                            fieldRecordload[idField] = false
                        }
                        if (itemFields.defaultValue === '1') {
                            setField(prevState => ({
                                ...prevState,
                                [idField]: true
                            }), []);
                            fieldRecordload[idField] = true
                        }
                        break;
                    default:

                        setField(prevState => ({
                            ...prevState,
                            [idField]: itemFields.defaultValue
                        }), []);

                        fieldRecordload[idField] = itemFields.defaultValue
                        break;
                }
            }

        })
    })

}

const initialDocGroup = (data, arrayResponse, setField, setGroup, fieldRecordload) => {

    for (let u = 0; u < data.crud.boxes.length; u++) {
        for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
            if (data.crud.boxes[u].fields[v].group !== null) {
                let objectsGroups = [];

                for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {
                    let objectGroup = {};
                    let arrayFields = [];
                    let nameGroup = data.crud.boxes[u].fields[v].group[b].name;
                    for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {

                        let itemFlag = JSON.parse(JSON.stringify(data.crud.boxes[u].fields[v].group[b].fields[m]));
                        let tamano = objectsGroups.length;
                        let newIdField = m + '_' + data.crud.boxes[u].fields[v].group[b].fields[m].id + '_' + m + tamano;
                        itemFlag.id = newIdField;
                        itemFlag.isGroup = true;

                        //buscar y reemplazar id de los where
                        if (itemFlag.where !== null) {
                            for (let r = 0; r < itemFlag.where.length; r++) {
                                if (itemFlag.where[r].field.length !== null) {
                                    for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                        let idField = itemFlag.where[r].field[d].idField;
                                        let existeIdGroup = false;

                                        for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                            if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                let tamano1 = objectsGroups.length;
                                                let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                existeIdGroup = true;
                                            }
                                        }

                                        if (existeIdGroup === false) {
                                            let newIdField1 = idField;
                                            itemFlag.where[r].field[d].idField = newIdField1;
                                        }
                                    }
                                }
                            }
                        }
                        //buscar y reemplazar id de los search source
                        if (itemFlag.searchSource !== null) {
                            for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                let idField = itemFlag.searchSource[r];
                                let existeIdGroup = false;
                                for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                    if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                        let tamano1 = objectsGroups.length;
                                        let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                        itemFlag.searchSource[r] = newIdField1;
                                        existeIdGroup = true;
                                    }
                                }

                                if (existeIdGroup === false) {
                                    let newIdField1 = idField;
                                    itemFlag.searchSource[r] = newIdField1;
                                }
                            }
                        }
                        arrayFields.push(itemFlag);

                        switch (itemFlag.type) {
                            case 'Select':
                                if (itemFlag.defaultValue) {

                                    if (arrayResponse) {
                                        arrayResponse.forEach((itemInfo) => {
                                            if (itemInfo.source === itemFlag.sourceSelect) {
                                                if (Number(itemFlag.defaultValue) === Number(itemInfo.id)) {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [newIdField]: {
                                                            id: itemInfo.id,
                                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        }
                                                    }), []);

                                                    fieldRecordload[newIdField] = {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    }
                                                }
                                            }
                                        })
                                    }
                                } else {
                                    setField(prevState => ({
                                        ...prevState,
                                        [newIdField]: null
                                    }));
                                    fieldRecordload[newIdField] = null;
                                }
                                break;
                            case 'MultipleSelect':
                                setField(prevState => ({
                                    ...prevState,
                                    [newIdField]: null
                                }));
                                fieldRecordload[newIdField] = null;
                                break;
                            case 'List':
                                setField(prevState => ({
                                    ...prevState,
                                    [newIdField]: null
                                }));
                                fieldRecordload[newIdField] = null;
                                break;
                            case 'Checkbox':
                                if (itemFlag.defaultValue === '0') {
                                    setField(prevState => ({
                                        ...prevState,
                                        [newIdField]: false
                                    }), []);

                                    fieldRecordload[newIdField] = false
                                }
                                if (itemFlag.defaultValue === '1') {
                                    setField(prevState => ({
                                        ...prevState,
                                        [newIdField]: true
                                    }), []);
                                    fieldRecordload[newIdField] = true
                                }
                                break;
                            case 'Switch':
                                if (itemFlag.defaultValue === '0') {
                                    setField(prevState => ({
                                        ...prevState,
                                        [newIdField]: false
                                    }), []);

                                    fieldRecordload[newIdField] = false
                                }
                                if (itemFlag.defaultValue === '1') {
                                    setField(prevState => ({
                                        ...prevState,
                                        [newIdField]: true
                                    }), []);
                                    fieldRecordload[newIdField] = true
                                }
                                break;
                            case 'Number':
                                setField(prevState => ({
                                    ...prevState,
                                    [newIdField]: itemFlag.defaultValue ? itemFlag.defaultValue : ''

                                }));
                                fieldRecordload[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                break;
                            case 'Currency':
                                setField(prevState => ({
                                    ...prevState,
                                    [newIdField]: itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                }));
                                fieldRecordload[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                break;
                            case 'Date':
                                if (itemFlag.defaultValue === 'CURDATE()') {
                                    setField(prevState => ({
                                        ...prevState,
                                        [newIdField]: new Date().toISOString().split('T')[0]
                                    }), []);
                                    fieldRecordload[newIdField] = new Date().toISOString().split('T')[0]
                                } else {

                                    if (itemFlag.defaultValue === 'BOM()') {

                                        const date = new Date();
                                        date.setDate(1);

                                        setField(prevState => ({
                                            ...prevState,
                                            [newIdField]: date.toISOString().split('T')[0]
                                        }));

                                        fieldRecordload[newIdField] = date.toISOString().split('T')[0]
                                    } else {
                                        if (itemFlag.defaultValue === 'BOY()') {
                                            const date = new Date();
                                            date.setMonth(0); // Enero
                                            date.setDate(1);  // Día 1
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: date.toISOString().split('T')[0]
                                            }));

                                            fieldRecordload[newIdField] = date.toISOString().split('T')[0]
                                        } else {
                                            if (itemFlag.defaultValue === 'YESTARDAY()') {
                                                const date = new Date();
                                                date.setDate(date.getDate() - 1);
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: date.toISOString().split('T')[0]
                                                }));

                                                fieldRecordload[newIdField] = date.toISOString().split('T')[0]
                                            } else {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: ''
                                                }));
                                                fieldRecordload[newIdField] = ''
                                            }
                                        }
                                    }
                                }
                                break;
                            default:

                                setField(prevState => ({
                                    ...prevState,
                                    [newIdField]: itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                }));
                                fieldRecordload[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                break;
                        }
                    }
                    objectGroup.fields = arrayFields;
                    objectsGroups.push(objectGroup);

                    setGroup(prevState => ({
                        ...prevState,
                        [nameGroup]: objectsGroups
                    }));
                }

            }
        }
    }
}

const initialDoc = {
    initialDocHeader,
    initialDocGroup
}

export default initialDoc;